module.exports = __webpack_public_path__ + "img/email-notification.ffac3bb5.svg";